import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c334c8a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "updateWebsiteModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "updateWebsiteModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title text-white" }, "Update Website", -1))
const _hoisted_6 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-dark" }, " An error has occurred and we will NOT automatically scrape your website. Please update your website. ", -1))
const _hoisted_8 = { class: "text-danger" }
const _hoisted_9 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_10 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = {
  for: "name",
  class: "form-label"
}
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = {
  key: 0,
  class: "text-danger ms-1"
}
const _hoisted_15 = {
  key: 1,
  class: "text-danger ms-1"
}
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "Activate daily detection of changes", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = {
  key: 1,
  class: "mb-3 position-relative"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "HTTP Headers (optional)", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 2,
  class: "modal-footer"
}
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WebsiteConfig = _resolveComponent("WebsiteConfig")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-close-white",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
            ref: "closeBtn"
          }, null, 512)
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", _hoisted_8, " Error: " + _toDisplayString(_ctx.error), 1),
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
              }, "Reset")
            ]))
          : _createCommentVNode("", true),
        (!_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (!_ctx.active)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Attention this website is not active and is not checked daily! "))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.data.type === 'HEALTHCHECK' ? 'Healtcheck Name' : 'Website URL'), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "name",
                  placeholder: _ctx.placeholder,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.url) = $event)),
                  onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"]))
                }, null, 40, _hoisted_13), [
                  [_vModelText, _ctx.url]
                ]),
                (_ctx.url && !_ctx.correctWebsiteUrl && !['SUBDOMAIN', 'SSL', 'HEALTHCHECK'].includes(_ctx.data.type))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, " A website URL must start with \"http://\" or \"https://\". "))
                  : _createCommentVNode("", true),
                (_ctx.url && _ctx.url.startsWith('http') && ['SUBDOMAIN', 'SSL'].includes(_ctx.data.type))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Please enter a domain WITHOUT https or http "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "",
                  id: "name",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.active) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.active]
                ])
              ]),
              (!['IMAGE', 'SUBDOMAIN', 'SSL', 'HEALTHCHECK'].includes(_ctx.data.type))
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _hoisted_21,
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (value, name) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: name,
                          class: "header-row"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((_ctx.headers[name].key) = $event),
                            placeholder: "Key",
                            class: "form-control"
                          }, null, 8, _hoisted_22), [
                            [_vModelText, _ctx.headers[name].key]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((_ctx.headers[name].value) = $event),
                            placeholder: "Value",
                            class: "form-control"
                          }, null, 8, _hoisted_23), [
                            [_vModelText, _ctx.headers[name].value]
                          ]),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.deleteHeader(name)),
                            class: "btn btn-outline-danger btn-small"
                          }, "-", 8, _hoisted_24)
                        ]))
                      }), 128)),
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addHeader && _ctx.addHeader(...args))),
                        class: "btn btn-outline-primary"
                      }, "+")
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_WebsiteConfig, {
                data: _ctx.data,
                websiteId: _ctx.website.websiteId
              }, null, 8, ["data", "websiteId"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary ms-2",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                disabled: _ctx.isDisabled
              }, _toDisplayString(_ctx.submitted ? "Updating" : "Update"), 9, _hoisted_26)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}